// This file was auto-generated by Fern from our API Definition.
export const ListOperator = {
    In: "in",
    NotIn: "not_in",
};
